export const fileTypes = {
  FILE: "file",
  FOLDER: "folder",
};

export const fileEntityTypes = {
  BRICK: "brick",
};
